import { Server, Lock, ShieldCheck, FileSearch } from "lucide-react";
import { Reveal, SectionTag } from "@/components/primitives";
import { useLanguage } from "@/hooks/use-language";

const ICONS = [Server, Lock, ShieldCheck, FileSearch];

const IMG =
  "https://images.unsplash.com/photo-1762163516269-3c143e04175c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxzZXJ2ZXIlMjByYWNrJTIwZGF0YSUyMGNlbnRlcnxlbnwwfHx8fDE3ODg2NzQ3NzB8MA&ixlib=rb-4.1.0&q=85";

export const Security = () => {
  const { t } = useLanguage();
  return (
  <section id="security" className="py-24 lg:py-32 border-b border-border" data-testid="security-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-16 items-start">
        <Reveal className="order-2 lg:order-1">
          <div className="relative border border-border overflow-hidden">
            <img src={IMG} alt="On-premise edge compute inside a plant" className="w-full h-[420px] lg:h-[560px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            <div className="absolute bottom-0 inset-x-0 p-8">
              <p className="font-display text-xs tracking-[0.3em] uppercase text-teal-300">{t.security.deployLabel}</p>
              <p className="mt-2 font-display font-bold text-lg text-white">{t.security.deployCaption}</p>
            </div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <SectionTag index="06" label={t.security.tag} />
            <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl">
              {t.security.h2}
            </h2>
            <p className="mt-6 max-w-xl text-base md:text-lg text-muted-foreground">
              {t.security.sub}
            </p>
          </Reveal>
          <div className="mt-12 grid sm:grid-cols-2 gap-px bg-border border border-border">
            {t.security.cards.map((card, i) => {
              const Icon = ICONS[i];
              return (
              <div key={card.title} className="group bg-background p-8 hover:bg-secondary/60 transition-colors duration-500" data-testid={`security-card-${i}`}>
                <Icon size={24} strokeWidth={1.5} className="text-teal-600 dark:text-teal-400 group-hover:scale-110 transition-transform duration-500" />
                <h3 className="mt-6 font-display font-bold text-base">{card.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{card.body}</p>
              </div>
              );
            })}
          </div>
          <Reveal delay={0.15}>
            <div className="mt-6 flex flex-wrap items-center gap-3" data-testid="compliance-chips">
              <span className="text-xs uppercase tracking-[0.25em] text-muted-foreground mr-2">{t.security.compliance}</span>
              {["ISO 27001", "SOC 2", "IEC 62443"].map((c) => (
                <span key={c} className="border border-border px-4 py-2 text-xs font-medium tracking-wide hover:border-teal-500/60 transition-colors duration-300">
                  {c}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
  );
};
